<template>
	<div class="w-100">
		<div class="">
			<h5 class="m-0">{{ filter_label }}</h5>
			<p style="font-size: .8rem">{{ filter_description }}</p>
		</div>
		<div class=" py-3">

			<div v-if="route == 'search'">
				<div  v-for="(data, index) in arr_filter_by" :key="index">
					<div v-if="data.count > 0" class="custom-control custom-checkbox mr-sm-2 d-flex align-items-center">
						<input type="checkbox" class="custom-control-input" :checked="data.selected_filter" @click="onSearchFilterClicked(index)" :id="'check'+data.data">
						<label class="custom-control-label" :for="'check'+data.data" style="font-size: .8rem">{{ data.label }} ({{ data.count }})</label>
					</div>
				</div>

				<p class="mb-1 font-weight-bold">{{ category_label }}</p>

				<div class="accordion mb-4" id="filterKategoriAccordion" style="font-size: .8rem">
					<div class="card" v-for="(data, index) in arr_tema1" :key="index">
						<div class="card-header" :id="'filter'+data.id">
							<button class="btn btn-link" :class="{ 'collapsed': data.selected_filter, }" type="button" data-toggle="collapse"
								:data-target="'#filter' + data.id + 'Collapse'"
								:aria-expanded="index == 0 ? 'true' : 'false'"
								:aria-controls="'filter' + data.id + 'Collapse'"
								style="font-size: .8rem">
								<p class="m-0 d-inline-block" :class="{'text-primary font-weight-bold' : data.selected_filter}" v-html="data.name"></p>
								<span class="badge badge-pill badge-primary">{{ data.count }}</span>
								<span class="card-header-angle valign-wrapper" >
									<i class="fa fa-angle-down"></i>
								</span>
							</button>
						</div>

						<div :id="'filter' + data.id + 'Collapse'" class="collapse"
							:class="{'show': data.selected_filter}"
							:aria-labelledby="'filter' + data.id"
							data-parent="#filterKategoriAccordion">
							<div class="card-body">
								<button class="btn btn-link d-flex justify-content-between align-items-center pr-0" type="button"
									v-for="(data1, index1) in data.sub_tema"
									@click="onSubTemaClicked(index, index1)"
									:key="index1"
									style="font-size: .8rem">
									<p class="m-0 d-inline-block" :class="{'text-primary font-weight-bold' : data1.selected_filter}" v-html="data1.name"></p>
									<span class="badge badge-pill badge-primary">{{ data1.count }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-else>
				<div class="accordion mb-4" id="filterAccordion">

					<div class="card" v-for="(data, index) in arr_filter_by" :key="index">
						<div class="card-header" :id="'filter'+data.data">
							<button class="btn btn-link " :class="{ 'collapsed': data.selected_filter, }" type="button" data-toggle="collapse"
								:data-target="'#filter' + data.data + 'Collapse'"
								aria-expanded="false"
								:aria-controls="'filter' + data.data + 'Collapse'"
								style="font-size: .8rem">
								<p class="m-0 d-inline-block" :class="{'text-primary font-weight-bold' : data.selected_filter}" v-html="data.label"></p>
								<span class="badge badge-pill badge-primary">{{ data.total }}</span>
								<span class="card-header-angle valign-wrapper">
									<i class="fa fa-angle-down"></i>
								</span>
							</button>
						</div>

						<div :id="'filter' + data.data + 'Collapse'" class="collapse"
							:class="{'show': data.selected_filter}" :aria-labelledby="'filter'+data.data" data-parent="#filterAccordion">
							<div class="card-body">
								<button class="btn btn-link d-flex justify-content-between align-items-center pr-0" type="button"
									:key="index1"
									v-for="(data1,index1) in data.sub_filter"
									@click="onSubFilterClicked(index, index1)"
									style="font-size: .8rem">
									<p class="m-0 d-inline-block" :class="{'text-primary font-weight-bold' : data1.selected_filter}" v-html="data1.name"></p>
									<span class="badge badge-pill badge-primary">{{ data1.count }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<p class="mb-1 font-weight-bold">{{ price_label }}</p>

			<div class="PriceRange" style="font-size: .8rem">
				<label for="minimumPrice">{{ minimum_label }}</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<div class="input-group-text" style="font-size: .8rem">Rp</div>
					</div>
					<input type="text" class="form-control" id="minimumPrice" placeholder="0" v-model="min_price" @change="$emit('filter_min_price', base.str_to_double(min_price))" style="font-size: .8rem">
				</div>
				<label for="maximumPrice">{{ maximum_label }}</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<div class="input-group-text" style="font-size: .8rem">Rp</div>
					</div>
					<input type="text" class="form-control" id="maximumPrice" placeholder="0" v-model="max_price" @change="$emit('filter_max_price', base.str_to_double(max_price))" style="font-size: .8rem">
				</div>
			</div>

			<div class="w-100 text-center">
				<button class="btn btn-primary" type="button" @click="reset_button" style="font-size: .8rem">
					{{ reset_label }}
				</button>

				<button class="btn btn-primary" style="font-size: .8rem" @click="onSubmitClicked">{{ submit_label }}</button>
			</div>

		</div>
	</div>
</template>

<script>
	import Base from '../base';
	import _ from 'lodash'

	export default {
		props:[
			'arr_tema', 'filter_by_arr', 'route', 'filter_label', 'filter_description', 'category_label', 'price_label', 'reset_label', 'submit_label', 'minimum_label', 'maximum_label', 'type',
		],
		data(){
			return{
				base: null,
				min_price: '0',
				max_price: '0',
				arr_filter_by: [],
				arr_tema1: [],
				from_system: false,
			}
		},
		computed:{
			is_filtered(){
				var flag = false, flag1 = false

				for(let temp of this.arr_filter_by){
					if(temp.sub_filter != null){
						for(let temp1 of temp.sub_filter){
							if(temp1.selected_filter){
								flag = true
								break
							}
						}
					}
					else{
						if(temp.selected_filter){
							flag = true
							break
						}
					}
				}

				for(let temp of this.arr_tema1){
					if(temp.sub_tema != null){
						for(let temp1 of temp.sub_tema){
							if(temp1.selected_filter){
								flag1 = true
								break
							}
						}
					}
				}

				return flag || flag1 || this.min_price != '0' || this.max_price != '0'
			},
		},
		watch: {
			filter_by_arr(val){
				this.arr_filter_by = val
			},
			arr_tema(val){
				this.arr_tema1 = val
			},
			min_price(val){
				if(this.from_system){
					this.from_system = false
					return
				}

				var max_price = this.base.str_to_double(this.max_price), min_price = this.base.str_to_double(val)
				this.min_price = this.base.to_currency_format(val)
				if(max_price < min_price){
					this.from_system = true
					this.max_price = this.base.to_currency_format(val)
				}
			},
			max_price(val){
				if(this.from_system){
					this.from_system = false
					return
				}

				var max_price = this.base.str_to_double(val), min_price = this.base.str_to_double(this.min_price)
				this.max_price = this.base.to_currency_format(val)
				if(max_price < min_price){
					this.from_system = true
					this.min_price = this.base.to_currency_format(val)
				}
			},
		},
		created() {
			this.base = new Base()
		},
		mounted(){
			this.arr_filter_by = this.filter_by_arr ? this.filter_by_arr : []
			this.arr_tema1 = this.arr_tema ? this.arr_tema : []
		},
		methods:{
			reset_button(){
			  this.min_price = '0'
			  this.max_price = '0'

				if(this.arr_filter_by != null){
					var arr = _.cloneDeep(this.arr_filter_by)
					for(let temp of arr){
						if(temp.sub_filter != null){
							for(let temp1 of temp.sub_filter)
								temp1.selected_filter = false
						}
						temp.selected_filter = false
					}
					this.arr_filter_by = arr
				}

				if(this.arr_tema1 != null){
					var arr = _.cloneDeep(this.arr_tema1)

					for(let temp of arr){
						if(temp.sub_tema != null){
							for(let temp1 of temp.sub_tema)
								temp1.selected_filter = false
						}
						temp.selected_filter = false
					}

					this.arr_tema1 = arr
				}

				window.scrollTo(0, 0)
				// if(this.type == null || (this.type != null && this.type != 'mobile'))
					this.$emit('reset')
			},
			onSearchFilterClicked(index){
				var temp = this.arr_filter_by[index]
				temp.selected_filter = !temp.selected_filter
				this.$set(this.arr_filter_by, index, temp)

				if(this.type == null || (this.type != null && this.type != 'mobile'))
					this.$emit('filter_by', temp.data)
			},
			onSubFilterClicked(index, index1){
				var temp = this.arr_filter_by[index]
				temp.sub_filter[index1].selected_filter = !temp.sub_filter[index1].selected_filter
				var flag = false, selected_filter = null
				for(let x in temp.sub_filter){
					if(x != index1)
						temp.sub_filter[x].selected_filter = false
					else{
						flag = temp.sub_filter[index1].selected_filter
						if(flag)
							selected_filter = temp.sub_filter[index1]
					}
				}
				temp.selected_filter = flag
				this.$set(this.arr_filter_by, index, temp)

				if(this.type == null || (this.type != null && this.type != 'mobile'))
					this.$emit('filter_by_category', selected_filter)
			},
			onSubTemaClicked(index, index1){
				var temp = this.arr_tema1[index], first_data = this.arr_tema1.length > 0 ? this.arr_tema1[0] : {}
				temp.sub_tema[index1].selected_filter = !temp.sub_tema[index1].selected_filter

				var flag = false, selected_filter = null
				for(let x in temp.sub_tema){
					if(x != index1)
						temp.sub_tema[x].selected_filter = false
					else{
						flag = temp.sub_tema[index1].selected_filter
						if(flag)
							selected_filter = temp.sub_tema[index1]
					}
				}

				temp.selected_filter = flag
				this.$set(this.arr_tema1, index, temp)

				if(!flag){
					first_data.selected_filter = true
					this.$set(this.arr_tema1, 0, first_data)
				}

				if(this.type == null || (this.type != null && this.type != 'mobile'))
					this.$emit('filter_by_category', selected_filter)
			},
			onSubmitClicked(){
				var arr_tema = _.cloneDeep(this.arr_tema1), arr_filter = _.cloneDeep(this.arr_filter_by), selected_tema = null, arr_selected_filter = []
				for(let temp of arr_tema){
					for(let temp1 of temp.sub_tema){
						if(temp1.selected_filter){
							selected_tema = temp1
							break
						}
					}

					if(selected_tema != null)
						break
				}

				for(let temp of arr_filter){
					if(temp.sub_filter != null){
						for(let temp1 of temp.sub_filter){
							if(temp1.selected_filter)
								arr_selected_filter.push(temp1)
						}
					}
					else{
						if(temp.selected_filter)
							arr_selected_filter.push(temp)
					}
				}

				this.$emit('onsubmit', {
					filter_by: arr_selected_filter,
					tema: selected_tema,
					min_price: this.base.str_to_double(this.min_price),
					max_price: this.base.str_to_double(this.max_price),
				})
			},
		},
	}
</script>
